// События App WS. HTTP-контракт генерируется из /openapi.json, а WS-протокол описан отдельно
// в /ws-protocol.json backend'а (app/ws/schemas.py), поэтому конверт и данные событий повторены здесь вручную.
// Необязательные поля backend не присылает вовсе (exclude_none), а не присылает `null`.

type MessageEventData = { messageId: string; deviceId: string; deliveryStatus: string };

export type AppWsEventData = {
  "message.created": MessageEventData;
  "message.status_changed": MessageEventData & { fromStatus: string; toStatus: string };
  "message.pinned_changed": MessageEventData & { pinned: boolean };
  "message.deleted": MessageEventData;
  "message.replayed": MessageEventData;
  "message.reaction_changed": MessageEventData & { likeCount: number };
  "device.status_changed": { deviceId: string; onlineStatus: string; lastSeenAt?: string };
  "device.queue_changed": {
    deviceId: string;
    queueItemId?: string;
    messageId?: string;
    status: string;
    attemptsCount?: number;
    queueSize?: number;
  };
  "invite.accepted": { deviceId: string; userId: string; inviteId: string };
  "guest.status_changed": { deviceId: string; userId?: string; status: string };
  "media.processed": {
    assetId: string;
    uploadId: string;
    deviceOptimizedFormat: string;
    deviceOptimizedWidth: number;
    deviceOptimizedHeight: number;
  };
  sync_required: { reason: string; assetId?: string };
};

export type AppWsEventName = keyof AppWsEventData;

export type AppWsEvent = {
  [Name in AppWsEventName]: {
    id: string;
    type: "event";
    event: Name;
    /** Растёт на единицу с каждым событием пользователя; пропуск значит, что события потеряны. */
    seq: number;
    ts: string;
    data: AppWsEventData[Name];
  };
}[AppWsEventName];

// Record, а не список: забытое событие — ошибка типов.
const knownEvents: Record<AppWsEventName, true> = {
  "message.created": true,
  "message.status_changed": true,
  "message.pinned_changed": true,
  "message.deleted": true,
  "message.replayed": true,
  "message.reaction_changed": true,
  "device.status_changed": true,
  "device.queue_changed": true,
  "invite.accepted": true,
  "guest.status_changed": true,
  "media.processed": true,
  sync_required: true,
};

/** Кадр App WS → событие; неизвестное событие (из будущей версии протокола) и мусор — `null`. */
export function parseAppEvent(raw: unknown): AppWsEvent | null {
  if (typeof raw !== "string") return null;
  let value: unknown;
  try {
    value = JSON.parse(raw);
  } catch {
    return null;
  }
  if (typeof value !== "object" || value === null) return null;
  const { type, event, seq, data } = value as Record<string, unknown>;
  if (type !== "event" || typeof event !== "string" || !Object.hasOwn(knownEvents, event)) return null;
  if (typeof seq !== "number" || typeof data !== "object" || data === null) return null;
  return value as AppWsEvent;
}
